module.exports = __webpack_public_path__ + "static/media/geesaa_1.89057c45.PNG";